import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-900 text-white section-padding">
      <div className="container-custom">
        <div className="py-12">
          <div className="grid md:grid-cols-4 gap-8">
            {/* Brand */}
            <div className="md:col-span-2">
              <div className="flex items-center space-x-3 mb-4">
                <img
                  src="/assets/png/richard-baird.png"
                  alt="Richard Baird"
                  className="w-12 h-12 rounded-full border-2 border-primary-400"
                />
                <span className="text-2xl font-bold">Richard J Baird</span>
              </div>
              <p className="text-dark-300 mb-6 max-w-md">
                Continuously learning and experimenting with new tech, from full stack frameworks to AI-powered solutions.
              </p>
              <div className="flex space-x-4">
                <a
                  href="https://linkedin.com/in/richardjbaird"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-dark-700 hover:bg-primary-600 rounded-lg flex items-center justify-center transition-colors duration-300"
                >
                  <img
                    src="/assets/png/linkedin-ico.png"
                    alt="LinkedIn"
                    className="w-5 h-5"
                  />
                </a>
                <a
                  href="https://github.com/rjcbaird"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-dark-700 hover:bg-primary-600 rounded-lg flex items-center justify-center transition-colors duration-300"
                >
                  <img
                    src="/assets/png/github-ico.png"
                    alt="GitHub"
                    className="w-5 h-5"
                  />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li>
                  <button
                    onClick={() => document.querySelector('#home')?.scrollIntoView({ behavior: 'smooth' })}
                    className="text-dark-300 hover:text-white transition-colors duration-200"
                  >
                    Home
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' })}
                    className="text-dark-300 hover:text-white transition-colors duration-200"
                  >
                    About
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => document.querySelector('#projects')?.scrollIntoView({ behavior: 'smooth' })}
                    className="text-dark-300 hover:text-white transition-colors duration-200"
                  >
                    Projects
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
                    className="text-dark-300 hover:text-white transition-colors duration-200"
                  >
                    Contact
                  </button>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            {/* <div>
              <h3 className="text-lg font-semibold mb-4">Contact</h3>
              <ul className="space-y-2 text-dark-300">                
                <li>Atlanta, GA</li>
              </ul>
            </div> */}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-dark-700 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-dark-300 text-sm">
              © {currentYear} Richard J Baird. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
